import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { HabilitacaoAlternativa } from "src/app/model/habilitacao-alternativa.model";
import Utils from "src/app/shared/fgi-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";

@Component({
    selector: 'app-habilitacao-alternativa-listagem',
    templateUrl: './habilitacao-alternativa-listagem.component.html',
    styleUrls: ['./habilitacao-alternativa-listagem.component.scss'],
    standalone: false
})
export class HabilitacaoAlternativaListagemComponent {


  @Input() habilitacoes: HabilitacaoAlternativa[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarHabilitacao: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarHabilitacoes: EventEmitter<any> = new EventEmitter<any>();
  @Output() public excluirHabilitacoes: EventEmitter<any> = new EventEmitter<any>();

  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public rowHovered: number | null = null;
  public idHabilitacaoAExcluir: number;

  @ViewChild('msgTemplateExcluir') msgTemplateExcluir: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosExcluir') botoesPersonalizadosExcluir: TemplateRef<any>;

  constructor(
    private bnModalService: BnModalMessageService,
    ){}

  ngOnInit() {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valorLimite') {
      funcao = parseFloat;
    }
    this.habilitacoes = this.habilitacoes.sort((a, b) => {
      if (ord.sentido == "asc") {
          return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
          return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarHabilitacoes() {
    this.exportarHabilitacoes.emit(null);
  }

  hover(index: number) {
    this.rowHovered = index;
  }

  hoverClean() {
    this.rowHovered = null;
  }

  modalConfirmarExclusao(event: Event, id: number) {
    event.stopPropagation();
    this.idHabilitacaoAExcluir = id;
    this.bnModalService.abrir(
      'Confirmação',
      'Esta ação irá EXCLUIR a linha selecionada. Você confirma?',
      'md',
      this.msgTemplateExcluir,
      this.botoesPersonalizadosExcluir
    );
  }

  excluir() {
    this.excluirHabilitacoes.emit(this.idHabilitacaoAExcluir);
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }

}
